import { compoundMapper } from "@povio/ui";
import { type VariantProps, cva } from "class-variance-authority";

import type { TypographyVariantProps } from "@/styles/overrides/typography.cva";

export const toggle = cva(
  "h-6 w-10 rounded-full before:m-0-5 before:block before:aspect-square before:h-5 before:rounded-full before:transition-transform before:content-[''] group-selected:before:translate-x-4",
  {
    variants: {
      variant: {
        default: [
          "bg-secondary-75",
          "text-text-default-2",
          "group-disabled:bg-secondary-75",
          "group-hover:bg-secondary-75",
          "group-pressed:bg-primary",
          "group-selected:bg-primary",
          "group-selected:group-disabled:bg-primary-500",
          "group-selected:group-hover:bg-primary",
          "group-selected:group-pressed:bg-secondary-75",
          "before:bg-secondary-200",
        ],
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export type ToggleVariantProps = VariantProps<typeof toggle>;

export const toggleTypography = compoundMapper<TypographyVariantProps, ToggleVariantProps>({
  default: {
    size: "label-1",
  },
});
